<template>
  <vs-prompt buttons-hidden	class="large" :title="data.id ? 'تعديل واجب' : 'إضافة واجب جديد'" :active="active" @close="close">

      <h4 class="mb-4">قم بادخال بيانات الواجب</h4>

      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <vs-input class="w-full" label="موضوع الواجب" v-model="formData.title"
                    v-validate="'required'"  name="title" data-vv-as="حقل موضوع الواجب"/>
          <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <label>وصف الواجب</label>
          <text-editor placeholder="قم بكتابة الوصف" v-model="formData.body" with-image
                       v-validate="'required'"  name="body" data-vv-as="الوصف" />
          <span class="text-danger text-sm" v-show="errors.has('body')">{{ errors.first('body') }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div v-if="file" class="vx-col w-full mb-4">
          <file @remove="file=null"
                :name="file.name"
                :size="file.size"
                :path="file.path"
                :progress="file.progress"
                :upload="file.upload"></file>
            <span class="text-danger text-sm" v-show="errors.has('file')">{{ errors.first('file') }}</span>
        </div>
        <div class="vx-col w-full mb-4">
          <input type="file" name="file" class="hidden" ref="uploadFile" data-vv-as="الملحق"
                 v-validate="'size:102400|mimes:image/*,.pdf,.zip,.rar,.doc,.docx,.ppt,.pptx'"
                 accept="image/*,.pdf,.zip,.rar,.doc,.docx,.ppt,.pptx"
                 @change="uploadFile">
          <div class="flex items-center">
            <vs-button v-if="file" class="mr-4" @click="file = null" color="danger" type="border"
                       icon="icon-x" icon-pack="feather" icon-after>حذف الملف</vs-button>
            <vs-button @click="$refs.uploadFile.click()" class="w-64" type="border"
                       icon="icon-upload" icon-pack="feather" icon-after>
              {{file ? 'تغيير الملف' : 'تحميل ملف'}}
            </vs-button>
          </div>
        </div>
      </div>
      <div class="vx-row items-center">
        <div class="vx-col sm:w-1/3 w-full mb-4">
          <label>وقت انتهاء الواجب</label>
          <flat-pickr class="w-full" :config="configDateTimePicker" v-model="formData.deadline"
                      v-validate="'required'" name="deadline" data-vv-as="وقت انتهاء الواجب" />
          <span class="text-danger text-sm" v-show="errors.has('deadline')">{{ errors.first('deadline') }}</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-4">
          <vs-input class="w-16" label="الدرجة" v-model="formData.mark"
                    v-validate="'required|numeric'"  name="mark" data-vv-as="الدرجة" />
          <span class="text-danger text-sm" v-show="errors.has('mark')">{{ errors.first('mark') }}</span>
        </div>
        <div class="vx-col w-full mb-4">
          <vs-checkbox class="mt-3" v-model="formData.stop_at_deadline">التوقف عن تسليم الواجب عند تاريخ الانهاء</vs-checkbox>
        </div>
        <div v-if="!formData.stop_at_deadline" class="vx-col mb-4">
          <label>عدد الأيام بعد الإقاف</label>
          <vs-input-number v-model="formData.days_after_deadline"
                    v-validate="'required|numeric'" name="days_after_deadline" data-vv-as="عدد الأيام بعد الإقاف" />
          <span class="text-danger text-sm" v-show="errors.has('days_after_deadline')">{{ errors.first('days_after_deadline') }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col">
          <label>اختر المجموعات</label>
          <ul class="centerx flex flex-wrap">
            <li v-for="(group, index) in getCourseDetails.groups" :key="index">
              <vs-checkbox v-model="formData.groups" :vs-value="group.group"
                           v-validate="'required'" name="groups" data-vv-as="المجموعات" data-vv-validate-on="change">
                {{group.group}}
              </vs-checkbox>
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('groups')">يجب اختيار مجموعة واحده علي الاقل</span>
        </div>
      </div>

      <vs-divider />
      <div class="flex justify-end">
        <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
        <vs-button @click="submitClicked">حفظ</vs-button>
      </div>
  </vs-prompt>
</template>
<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { Arabic } from "flatpickr/dist/l10n/ar.js"

    import assignmentsAPI from "../../../api/assignmentsAPI";
    import TextEditor from '@/views/components/TextEditor'

    export default {
        name: 'AssignmentForm',
        components:{
          TextEditor,
            flatPickr,
        },
        props: {
            data: {
                required: true,
                type: Object
            },
            active: {
                required: true,
                default: false,
                type: Boolean
            },
        },
        watch: {
            active(val){
                if(!val) return

                this.intiValues()

                if(this.data.id) {
                    Object.assign(this.formData, this.data)
                    this.file = this.data.file.name ? Object.assign({}, this.data.file) : null
                }
            },
        },
        data() {
            return {
                formData: {
                    title: '',
                    body: '',
                    deadline: null,
                    stop_at_deadline: true,
                    days_after_deadline: 0,
                    mark: 10,
                    file: null,
                    groups: [],
                },
                configDateTimePicker: {
                    disableMobile: "true",
                    minDate: this.$store.state.date,
                    minuteIncrement: 1,
                    dateFormat: 'Y-m-d',
                    locale: Arabic,
                },
                file: null,
            }
        },
        methods: {
            uploadFile($event){
                if($event.target.files.length === 0) return
                this.file = {
                    data: $event.target.files[0],
                    name: $event.target.files[0].name,
                    size: $event.target.files[0].size,
                    progress: null,
                    upload: true,
                }
            },
            submitClicked(){
                if(this.formData.stop_at_deadline){
                    this.formData.days_after_deadline = 0
                }
                this.$validator.validateAll().then((result) => {
                    if(result) {
                        this.$startLoading()
                        this.formData.file = this.file && this.file.data ? this.file.data : null
                        if(this.data.id) {
                            this.updateAssignment()
                        } else {
                            this.addAssignment()
                        }
                    }
                })
            },
            addAssignment(){
                const data = new FormData()
                if(typeof this.formData.deadline === 'object') {
                    this.formData.deadline = `${this.formData.deadline.getFullYear()}-${this.formData.deadline.getMonth()+1}-${this.formData.deadline.getDate()}`
                }
                Object.keys(this.formData).forEach(key => data.append(key, this.formData[key]))

                assignmentsAPI.create(data)
                    .then(response => {
                        this.formData.id = response.data.id
                        this.formData.file = response.data.file
                        this.submitRequest()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },
            updateAssignment(){
                const data = new FormData()
                Object.keys(this.formData).forEach(key => data.append(key, this.formData[key]))
                if(!this.file || !this.file.path) data.append('file_changed', 'true')

                assignmentsAPI.update(this.data.id, data)
                    .then(response => {
                        this.formData.file = response.data.file
                        this.submitRequest()
                        this.$notifySuccess(response.successMessage)
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
                    .finally(() => this.$closeLoading())
            },

            // this method calls when the request is success and delivered
            submitRequest(){
                let data = {}
                Object.assign(data, this.formData)
                this.$emit('submit', data)
                this.close()
            },

            close(){
                this.$emit('update:active', false)
            },

            intiValues(){
                this.formData = {
                    title: '',
                    body: '',
                    deadline: null,
                    stop_at_deadline: true,
                    days_after_deadline: 0,
                    mark: 10,
                    file: null,
                    groups: [],
                }
                this.file = null
            },
        },
    }
</script>
